import { createFileRoute } from '@tanstack/react-router'
import { requireAdmin } from '@/lib/auth-guards'
import { RutCheckOutPage } from '@/features/check-ins/rut-checkout-page'

export const Route = createFileRoute('/_authenticated/check-ins/rut-checkout')({
  beforeLoad: requireAdmin,
  component: RutCheckOutPage,
})
